import api from './api';

export const equipmentMaintenanceApi = {
  getAll: async (params = {}) => {
    const response = await api.get('/equipment-maintenance', { params });
    return response.data?.data ?? [];
  },
  
  getById: async (id: number) => {
    const response = await api.get(`/equipment-maintenance/${id}`);
    return response.data;
  },
  
  create: async (data: any) => {
    const response = await api.post('/equipment-maintenance', data);
    return response.data;
  },
  
  update: async (id: number, data: any) => {
    const response = await api.put(`/equipment-maintenance/${id}`, data);
    return response.data;
  },
  
  delete: async (id: number) => {
    const response = await api.delete(`/equipment-maintenance/${id}`);
    return response.data;
  },

  // New methods for dropdown data
  getDescriptions: async () => {
    const response = await api.get('/equipment-maintenance-dropdown/descriptions');
    return response.data?.data ?? [];
  },

  getCoaches: async () => {
    const response = await api.get('/equipment-maintenance-dropdown/coaches');
    return response.data?.data ?? { area_coaches: [], regional_coaches: [], rgms: [] };
  },

  getCategories: async () => {
    const response = await api.get('/equipment-maintenance-dropdown/categories');
    return response.data?.data ?? [];
  },

  getStoreDetails: async (storeNumber: string) => {
    const response = await api.get('/equipment-maintenance-dropdown/store-details', {
      params: { store_number: storeNumber }
    });
    return response.data?.data ?? null;
  },

  getCoachesByStore: async (storeNumber: string) => {
    const response = await api.get('/equipment-maintenance-dropdown/coaches-by-store', {
      params: { store_number: storeNumber }
    });
    return response.data?.data ?? { area_coach: null, regional_coach: null };
  },

  getDescriptionsByCategory: async (categoryId: number) => {
    const response = await api.get('/equipment-maintenance-dropdown/descriptions-by-category', {
      params: { category_id: categoryId }
    });
    return response.data?.data ?? [];
  },

  getDescriptionsBySubcategory: async (subcategoryId: number) => {
    const response = await api.get('/equipment-maintenance-dropdown/descriptions-by-subcategory', {
      params: { subcategory_id: subcategoryId }
    });
    return response.data?.data ?? [];
  },

  getDescriptionDetails: async (description: string) => {
    const response = await api.get('/equipment-maintenance-dropdown/description-details', {
      params: { description }
    });
    return response.data?.data ?? null;
  },

  getSubcategories: async (categoryId: number) => {
    const response = await api.get(`/equipment-maintenance/subcategories/${categoryId}`);
    return response.data?.data ?? [];
  },
};